import { Component, OnInit } from '@angular/core';
import { BrandingMessages } from '../../../appconfig';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit {

  copyrightMessage: string = BrandingMessages.copyrightMessage;
  constructor() { }

  ngOnInit(): void {
  }

  redirectToLogin() {
    window.location.href = '/login';
  }

  notifyme() {
    alert('This feature is coming soon!');
    const emailId = (document.getElementById('emailInput') as HTMLInputElement)?.value;
    // if (!emailId) {
    //   alert('Please enter an email address');
    //   return;
    // }

    this.sendEmail(emailId);
  }

  private sendEmail(emailId: string): void {
    const message = `A lead has been generated for email: ${emailId}`;
    // Call your backend email service
    // this.emailService.sendEmail({ to: 'recipient@example.com', body: message });
  }
}
